// React libraries
import React, { useState } from "react";
// Custom Styles
import { useStyles } from "./DropdownStyles";
// Components
import { Typography, OverflowMenuSelection } from "../index";
// Assets
import { ArrowHeadDown } from "../../icons";
// Constants
import { Color, FONT_FAMILY } from "../../constants";
export const Dropdown = (props) => {
    const classes = useStyles(props);
    const { id = "", menu = [], selected = null, backgroundColor, style, placeholder, withCheckMark = true } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    let defaultItem = null;
    let defaultPlaceholder = "";
    if (selected) {
        defaultItem = selected;
    }
    // else if (selected === null || typeof selected === 'undefined') {
    //     // defaultItem = menu[0].text
    // }
    if (placeholder) {
        defaultPlaceholder = placeholder;
    }
    const [selectedItem, setSelectedItem] = useState(defaultItem);
    const handleClickMenuSelection = (event) => {
        if (!anchorEl) {
            setAnchorEl(event.currentTarget);
        }
        ;
    };
    return (React.createElement("div", { id: id, className: classes.dropdownContainer, "aria-controls": `${id}-dropdownMenu`, "aria-haspopup": "true", onClick: handleClickMenuSelection, style: Object.assign({ background: backgroundColor }, style) },
        React.createElement("div", { id: `${id}-dropdownText`, className: classes.dropdownText },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[400] }, selectedItem ? selectedItem : placeholder)),
        React.createElement("div", { id: `${id}-dropdownArrow`, className: classes.dropdownArrowIcon },
            React.createElement(ArrowHeadDown, null)),
        React.createElement(OverflowMenuSelection, { id: `${id}-dropdownMenu`, anchorElement: anchorEl, menuItems: menu ? menu : [], setValue: setSelectedItem, setAnchorEl: setAnchorEl, selectedItem: selectedItem, menuWidth: style === null || style === void 0 ? void 0 : style.width, withCheckMark: withCheckMark ? true : false })));
};
export default React.memo(Dropdown);
